import api from './api';

export interface ScheduleItem {
  id_task: string;
  id: number;
  project_id: string;
  ssp: string;
  task: string;
  days: number;
  start_date: string;
  end_date: string;
  predecessor: string | null;
  value: number;
  resource: string | null;
  notes: string | null;
  expected_progress: number;
  expected_progress_date: string | null;
  actual_progress: number;
  actual_progress_date: string | null;
  delay?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateScheduleItemRequest {
  project_id: string;
  ssp: string;
  task: string;
  days: number;
  start_date: string;
  predecessor?: string;
  value?: number;
  resource?: string;
  notes?: string;
  actual_progress?: number;
}

export interface UpdateScheduleItemRequest {
  ssp?: string;
  task?: string;
  days?: number;
  start_date?: string;
  predecessor?: string;
  value?: number;
  resource?: string;
  notes?: string;
  actual_progress?: number;
}

export interface UpdateProgressRequest {
  actual_progress: number;
  actual_progress_date?: string;
}

const scheduleService = {
  // Pobierz wszystkie zadania harmonogramu dla projektu
  getScheduleItemsByProject: async (projectId: string): Promise<ScheduleItem[]> => {
    try {
      const response = await api.get(`/schedule-items/project/${projectId}`);
      // Backend może zwrócić { success, data } – normalizujemy
      const payload = response.data;
      if (payload && Array.isArray(payload.data)) return payload.data as ScheduleItem[];
      return Array.isArray(payload) ? payload : [];
    } catch (error) {
      console.error('Błąd podczas pobierania zadań harmonogramu:', error);
      throw error;
    }
  },

  // Pobierz szczegóły zadania harmonogramu
  getScheduleItemById: async (id: string): Promise<ScheduleItem> => {
    try {
      const response = await api.get(`/schedule-items/${id}`);
      return response.data;
    } catch (error) {
      console.error('Błąd podczas pobierania szczegółów zadania harmonogramu:', error);
      throw error;
    }
  },

  // Dodaj nowe zadanie harmonogramu
  createScheduleItem: async (data: CreateScheduleItemRequest): Promise<ScheduleItem> => {
    try {
      const response = await api.post('/schedule-items', data);
      return response.data;
    } catch (error) {
      console.error('Błąd podczas dodawania zadania harmonogramu:', error);
      throw error;
    }
  },

  // Aktualizuj zadanie harmonogramu
  updateScheduleItem: async (id: string, data: UpdateScheduleItemRequest): Promise<ScheduleItem> => {
    try {
      const response = await api.put(`/schedule-items/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Błąd podczas aktualizacji zadania harmonogramu:', error);
      throw error;
    }
  },

  // Usuń zadanie harmonogramu
  deleteScheduleItem: async (id: string): Promise<void> => {
    try {
      await api.delete(`/schedule-items/${id}`);
    } catch (error) {
      console.error('Błąd podczas usuwania zadania harmonogramu:', error);
      throw error;
    }
  },

  // Aktualizuj faktyczne zaawansowanie zadania
  updateProgress: async (id: string, data: UpdateProgressRequest): Promise<ScheduleItem> => {
    try {
      const response = await api.patch(`/schedule-items/${id}/progress`, data);
      return response.data;
    } catch (error) {
      console.error('Błąd podczas aktualizacji faktycznego zaawansowania:', error);
      throw error;
    }
  }
};

export default scheduleService;
